import { render, staticRenderFns } from "./modalManageQueues.vue?vue&type=template&id=20bd8838&scoped=true"
import script from "./modalManageQueues.vue?vue&type=script&lang=js"
export * from "./modalManageQueues.vue?vue&type=script&lang=js"
import style0 from "./modalManageQueues.vue?vue&type=style&index=0&id=20bd8838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd8838",
  null
  
)

export default component.exports